'use client';

import React from 'react';
import { motion } from 'framer-motion';

// Kodning har bir qatori uchun ma'lumotlar va sintaksis turlari
const codeContent = [
    { type: 'line', content: [ { type: 'keyword', text: 'const ' }, { type: 'variable', text: 'NegaHVNDevelopers' }, { type: 'default', text: ' = {' } ] },
    { type: 'line', isIndented: true, content: [ { type: 'property', text: 'UI_UX: ' }, { type: 'string', text: '"Premium & Minimalist Dizayn",' } ] },
    { type: 'line', isIndented: true, content: [ { type: 'property', text: 'Tezlik: ' }, { type: 'string', text: '"95+ PageSpeed (Next.js / Vite)",' } ] },
    { type: 'line', isIndented: true, content: [ { type: 'property', text: 'Kod_Sifati: ' }, { type: 'string', text: '"Clean Architecture & Scalable",' } ] },
    { type: 'line', isIndented: true, content: [ { type: 'property', text: 'Xavfsizlik: ' }, { type: 'string', text: '"Supabase & Stripe Integratsiyasi",' } ] },
    { type: 'line', isIndented: true, content: [ { type: 'property', text: 'Qo_llab_quvvatlash: ' }, { type: 'string', text: '"24/7 Doimiy Texnik Ko_mak"' } ] },
    { type: 'line', content: [ { type: 'default', text: '};' } ] },
];

// Har bir sintaksis turi uchun Tailwind CSS ranglari
const syntaxColors: { [key: string]: string } = {
  keyword: 'text-purple-400',
  variable: 'text-blue-400',
  property: 'text-cyan-400',
  string: 'text-emerald-300',
  default: 'text-zinc-300',
};

// Framer Motion animatsiya variantlari
const containerVariants = {
  hidden: { opacity: 0, y: 30 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6,
      ease: [0.33, 1, 0.68, 1],
      staggerChildren: 0.07,
    },
  },
};

const lineVariants = {
  hidden: { opacity: 0, x: -15 },
  visible: { opacity: 1, x: 0 },
};

export function WhyUsCodeBlock() {
  return (
    <section className="py-20 md:py-28 bg-white dark:bg-black">
      <div className="container mx-auto px-6">
        <motion.div 
            initial={{ opacity: 0, y: 20 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: '-100px' }}
            transition={{ duration: 0.6 }}
            className="max-w-3xl mx-auto"
        >
          <div className="bg-zinc-950 rounded-xl shadow-2xl overflow-hidden border border-zinc-800">
            {/* Oyna boshqaruv paneli */}
            <div className="h-8 bg-zinc-900/70 flex items-center px-4 border-b border-zinc-800">
              <div className="flex space-x-1.5">
                <div className="w-2.5 h-2.5 bg-red-500 rounded-full"></div>
                <div className="w-2.5 h-2.5 bg-yellow-500 rounded-full"></div>
                <div className="w-2.5 h-2.5 bg-green-500 rounded-full"></div>
              </div>
            </div>

            {/* Kod maydoni */}
            <motion.div 
                className="flex text-sm p-6"
                initial="hidden"
                whileInView="visible"
                variants={containerVariants}
                viewport={{ once: true, margin: '-150px' }}
            >
              {/* Qator raqamlari */}
              <div className="font-mono text-zinc-700 select-none pr-6 text-right">
                {Array.from({ length: codeContent.length }, (_, i) => (
                  <motion.div key={i} variants={lineVariants}>
                    {i + 1}
                  </motion.div>
                ))}
              </div>

              {/* Sintaksisli kod */}
              <pre className="font-mono whitespace-pre-wrap flex-1">
                  {codeContent.map((line, i) => (
                    <motion.div key={i} variants={lineVariants} className={line.isIndented ? 'pl-4' : ''}>
                      {line.content.map((part, j) => (
                          <span key={j} className={syntaxColors[part.type]}>
                              {part.text}
                          </span>
                      ))}
                    </motion.div>
                  ))}
              </pre>
            </motion.div>
          </div>
        </motion.div>
      </div>
    </section>
  );
}
